import { LOGOUT, REHYDRATE, CHOOSE_COMPANY, UPDATE_COMPANY } from "@Actions/types";

export default function reducer(
	state = {
		companyId: 0,
		name: "",
		logo: "",
		settings: {},
		companyFields: {},
		groups: [],
		channels: [],
	},
	action
) {
	const { payload, type } = action;
	switch (type) {
		case LOGOUT: {
			return {
				...state,
				companyId: 0,
				name: "",
				logo: "",
				settings: {},
				companyFields: {},
				groups: [],
				channels: [],
			};
		}

		case REHYDRATE: {
			return {
				...state,
				companyId: payload.data.company.companyId,
				name: payload.data.company.name,
				logo: payload.data.company.logo,
				settings: payload.data.company.settings,
				companyFields: payload.data.company.companyFields,
				groups: payload.data.company.groups,
				channels: payload.data.company.channels,
			};
		}

		case CHOOSE_COMPANY: {
			return {
				...state,
				companyId: payload.data.company.id,
				name: payload.data.company.name,
				logo: payload.data.company.logo,
				settings: payload.data.company.settings,
				companyFields: payload.data.company.companyFields,
				groups: payload.data.company.groups,
				channels: payload.data.company.channels,
			};
		}

		case UPDATE_COMPANY: {
			return {
				...state,
				name: payload.data.name,
				logo: payload.data.logo,
				settings: payload.data.settings,
				companyFields: payload.data.companyFields,
				groups: payload.data.groups,
				channels: payload.data.channels,
			};
		}

		default:
			return state;
	}
}
